var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInVoiceEmptyPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 634146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 82.8096,
    cy: 82.2598,
    r: 82,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5315",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Receipt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M136.384 52.7394V63.3229C136.384 70.2328 132.01 74.6061 125.1 74.6061H110.144V44.0365C110.144 39.1821 114.123 35.2461 118.978 35.2461C123.745 35.2898 128.118 37.2141 131.267 40.3629C134.416 43.5554 136.384 47.9288 136.384 52.7394Z",
    fill: "white",
    stroke: "#888888",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.917 57.1128V118.339C48.917 121.969 53.0279 124.025 55.9143 121.838L63.3927 116.24C65.1421 114.928 67.5911 115.103 69.1655 116.678L76.4253 123.981C78.1309 125.687 80.9298 125.687 82.6354 123.981L89.9826 116.634C91.5133 115.103 93.9623 114.928 95.6679 116.24L103.146 121.838C106.033 123.981 110.144 121.926 110.144 118.339V43.9928C110.144 39.1821 114.08 35.2461 118.89 35.2461H70.7837H66.4103C53.2903 35.2461 48.917 43.0744 48.917 52.7394V57.1128Z",
    fill: "white",
    stroke: "#888888",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.5303 99.7969H92.6503",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M79.5303 82.3008H92.6503",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3916 99.752H66.4309H66.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3916 99.752H66.4309",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3916 82.2598H66.4309H66.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3916 82.2598H66.4309",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "$",
    d: "M87.8369 70.4803V40.6621H89.7472V70.4803H87.8369ZM92.9037 50.5044C92.8105 49.5649 92.4106 48.8349 91.704 48.3147C90.9974 47.7944 90.0384 47.5343 88.827 47.5343C88.0039 47.5343 87.3089 47.6507 86.7421 47.8837C86.1752 48.1089 85.7404 48.4234 85.4375 48.8272C85.1424 49.231 84.9949 49.6891 84.9949 50.2016C84.9794 50.6287 85.0687 51.0014 85.2628 51.3198C85.4647 51.6382 85.7404 51.9138 86.0898 52.1468C86.4392 52.372 86.843 52.57 87.3012 52.7408C87.7593 52.9039 88.2485 53.0436 88.7688 53.1601L90.912 53.6726C91.9525 53.9056 92.9076 54.2162 93.7773 54.6044C94.647 54.9927 95.4002 55.4703 96.037 56.0371C96.6737 56.604 97.1668 57.2718 97.5162 58.0405C97.8734 58.8093 98.0559 59.6906 98.0637 60.6846C98.0559 62.1444 97.6832 63.4101 96.9455 64.4817C96.2155 65.5455 95.1595 66.3725 93.7773 66.9627C92.4029 67.5451 90.745 67.8363 88.8037 67.8363C86.878 67.8363 85.2007 67.5412 83.7719 66.951C82.3509 66.3609 81.2405 65.4873 80.4406 64.3303C79.6486 63.1655 79.2332 61.7251 79.1943 60.009H84.0747C84.1291 60.8088 84.3582 61.4766 84.7619 62.0124C85.1735 62.5404 85.7209 62.9403 86.4043 63.2121C87.0954 63.4761 87.8758 63.6081 88.7455 63.6081C89.5996 63.6081 90.3412 63.4839 90.9702 63.2354C91.6069 62.9869 92.1 62.6414 92.4495 62.1988C92.7989 61.7561 92.9736 61.2475 92.9736 60.6729C92.9736 60.1371 92.8144 59.6867 92.496 59.3218C92.1854 58.9568 91.7273 58.6462 91.1216 58.39C90.5237 58.1337 89.7899 57.9007 88.9202 57.6911L86.3227 57.0388C84.3116 56.5496 82.7236 55.7847 81.5588 54.7442C80.3941 53.7037 79.8155 52.3021 79.8233 50.5394C79.8155 49.0951 80.1999 47.8332 80.9764 46.7539C81.7607 45.6745 82.8362 44.832 84.2029 44.2263C85.5695 43.6206 87.1226 43.3178 88.8619 43.3178C90.6324 43.3178 92.1777 43.6206 93.4977 44.2263C94.8256 44.832 95.8584 45.6745 96.596 46.7539C97.3337 47.8332 97.7142 49.0834 97.7375 50.5044H92.9037Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5099"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 184",
    cx: 113.969,
    cy: 41.2594,
    r: 16.4,
    fill: "#F25E4A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.373 34.6633C107.653 34.3831 108.108 34.3831 108.388 34.6633L120.564 46.8397C120.845 47.1199 120.845 47.5741 120.564 47.8544C120.284 48.1346 119.83 48.1346 119.55 47.8544L107.373 35.678C107.093 35.3978 107.093 34.9435 107.373 34.6633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.564 34.6633C120.845 34.9435 120.845 35.3978 120.564 35.678L108.388 47.8544C108.108 48.1346 107.654 48.1346 107.373 47.8544C107.093 47.5742 107.093 47.1199 107.373 46.8397L119.55 34.6633C119.83 34.3831 120.284 34.3831 120.564 34.6633Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M35.055 88.8223H63.2967C72.3462 88.8223 74.6086 91.0308 74.6086 99.8398V120.444C74.6086 129.254 72.3462 131.462 63.3221 131.462H35.055C26.0309 131.487 23.7686 129.279 23.7686 120.47V99.8398C23.7686 91.0308 26.0309 88.8223 35.055 88.8223Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.0479 101.744H71.3296",
    stroke: "#888888",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.2295 121.621L54.1095 121.621",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0991 113.485C28.7481 113.485 28.4491 113.39 28.2022 113.199C27.9553 113.006 27.7666 112.727 27.6361 112.363C27.5057 111.996 27.4404 111.553 27.4404 111.035C27.4404 110.519 27.5057 110.079 27.6361 109.714C27.7681 109.347 27.9576 109.068 28.2045 108.875C28.453 108.681 28.7512 108.584 29.0991 108.584C29.4469 108.584 29.7444 108.681 29.9913 108.875C30.2398 109.068 30.4292 109.347 30.5597 109.714C30.6917 110.079 30.7577 110.519 30.7577 111.035C30.7577 111.553 30.6925 111.996 30.562 112.363C30.4316 112.727 30.2429 113.006 29.9959 113.199C29.749 113.39 29.4501 113.485 29.0991 113.485ZM29.0991 112.973C29.4469 112.973 29.7172 112.805 29.9097 112.47C30.1023 112.134 30.1986 111.656 30.1986 111.035C30.1986 110.622 30.1544 110.27 30.0658 109.979C29.9789 109.689 29.8531 109.468 29.6884 109.315C29.5254 109.163 29.3289 109.087 29.0991 109.087C28.7543 109.087 28.4848 109.257 28.2907 109.597C28.0966 109.936 27.9995 110.415 27.9995 111.035C27.9995 111.448 28.043 111.799 28.13 112.088C28.2169 112.376 28.342 112.596 28.505 112.747C28.6697 112.898 28.8677 112.973 29.0991 112.973Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0191 113.485C33.6681 113.485 33.3691 113.39 33.1222 113.199C32.8753 113.006 32.6866 112.727 32.5561 112.363C32.4257 111.996 32.3604 111.553 32.3604 111.035C32.3604 110.519 32.4257 110.079 32.5561 109.714C32.6881 109.347 32.8776 109.068 33.1245 108.875C33.373 108.681 33.6712 108.584 34.0191 108.584C34.3669 108.584 34.6644 108.681 34.9113 108.875C35.1598 109.068 35.3492 109.347 35.4797 109.714C35.6117 110.079 35.6777 110.519 35.6777 111.035C35.6777 111.553 35.6125 111.996 35.482 112.363C35.3516 112.727 35.1629 113.006 34.9159 113.199C34.669 113.39 34.3701 113.485 34.0191 113.485ZM34.0191 112.973C34.3669 112.973 34.6372 112.805 34.8297 112.47C35.0223 112.134 35.1186 111.656 35.1186 111.035C35.1186 110.622 35.0744 110.27 34.9858 109.979C34.8989 109.689 34.7731 109.468 34.6084 109.315C34.4454 109.163 34.2489 109.087 34.0191 109.087C33.6743 109.087 33.4048 109.257 33.2107 109.597C33.0166 109.936 32.9195 110.415 32.9195 111.035C32.9195 111.448 32.963 111.799 33.05 112.088C33.1369 112.376 33.262 112.596 33.425 112.747C33.5897 112.898 33.7877 112.973 34.0191 112.973Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9391 113.485C38.5881 113.485 38.2891 113.39 38.0422 113.199C37.7953 113.006 37.6066 112.727 37.4761 112.363C37.3457 111.996 37.2804 111.553 37.2804 111.035C37.2804 110.519 37.3457 110.079 37.4761 109.714C37.6081 109.347 37.7976 109.068 38.0445 108.875C38.293 108.681 38.5912 108.584 38.9391 108.584C39.2869 108.584 39.5844 108.681 39.8313 108.875C40.0798 109.068 40.2692 109.347 40.3997 109.714C40.5317 110.079 40.5977 110.519 40.5977 111.035C40.5977 111.553 40.5325 111.996 40.402 112.363C40.2716 112.727 40.0829 113.006 39.8359 113.199C39.589 113.39 39.2901 113.485 38.9391 113.485ZM38.9391 112.973C39.2869 112.973 39.5572 112.805 39.7497 112.47C39.9423 112.134 40.0386 111.656 40.0386 111.035C40.0386 110.622 39.9944 110.27 39.9058 109.979C39.8189 109.689 39.6931 109.468 39.5284 109.315C39.3654 109.163 39.1689 109.087 38.9391 109.087C38.5943 109.087 38.3248 109.257 38.1307 109.597C37.9366 109.936 37.8395 110.415 37.8395 111.035C37.8395 111.448 37.883 111.799 37.97 112.088C38.0569 112.376 38.182 112.596 38.345 112.747C38.5097 112.898 38.7077 112.973 38.9391 112.973Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8591 113.485C43.5081 113.485 43.2091 113.39 42.9622 113.199C42.7153 113.006 42.5266 112.727 42.3961 112.363C42.2657 111.996 42.2004 111.553 42.2004 111.035C42.2004 110.519 42.2657 110.079 42.3961 109.714C42.5281 109.347 42.7176 109.068 42.9645 108.875C43.213 108.681 43.5112 108.584 43.8591 108.584C44.2069 108.584 44.5044 108.681 44.7513 108.875C44.9998 109.068 45.1892 109.347 45.3197 109.714C45.4517 110.079 45.5177 110.519 45.5177 111.035C45.5177 111.553 45.4525 111.996 45.322 112.363C45.1916 112.727 45.0029 113.006 44.7559 113.199C44.509 113.39 44.2101 113.485 43.8591 113.485ZM43.8591 112.973C44.2069 112.973 44.4772 112.805 44.6697 112.47C44.8623 112.134 44.9586 111.656 44.9586 111.035C44.9586 110.622 44.9143 110.27 44.8258 109.979C44.7389 109.689 44.6131 109.468 44.4484 109.315C44.2854 109.163 44.0889 109.087 43.8591 109.087C43.5143 109.087 43.2448 109.257 43.0507 109.597C42.8566 109.936 42.7595 110.415 42.7595 111.035C42.7595 111.448 42.803 111.799 42.89 112.088C42.9769 112.376 43.102 112.596 43.265 112.747C43.4297 112.898 43.6277 112.973 43.8591 112.973Z",
    fill: "#232323"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInVoiceEmptyPrimary);
export default __webpack_public_path__ + "static/media/inVoiceEmptyPrimary.27fe93d221390de818c199cd3533bdd3.svg";
export { ForwardRef as ReactComponent };